import { CSSProperties } from 'react';

export const labelStyle: CSSProperties = {
  color: 'rgba(0, 0, 0, 0.54)',
  margin: '0 0 10px 0',
  fontSize: '0.6964285714285714rem',
  lineHeight: '1em',
};

export const fieldStyle: CSSProperties = {
  marginBottom: '20px',
};

// Utility function to recursively remove __typename fields
export const removeTypename = (obj: any): any => {
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(removeTypename);
  }

  const cleaned: any = {};
  for (const key in obj) {
    if (key !== '__typename' && obj.hasOwnProperty(key)) {
      cleaned[key] = removeTypename(obj[key]);
    }
  }
  return cleaned;
};
